import { Options } from "@contentful/rich-text-react-renderer";
import { defaultRichTextOptions } from "../../utils/contentful/rich-text-formatting";
import { BLOCKS } from "@contentful/rich-text-types";
import { FONTS, fontSize } from "../../styles/fonts";
import { css } from "@emotion/react";

export const richTextOptions: Options = {
  ...defaultRichTextOptions,
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return (
        <p
          className={node.data?.className}
          css={[
            fontSize.x25,
            FONTS.SwarovskiFutura300,
            css`
              margin-top: 0;
            `,
          ]}
        >
          {children}
        </p>
      );
    },
  },
};
